import Button from '@repo/ui/button'
import { PlusIcon } from '@repo/ui/icons'
import Typography from '@repo/ui/typography'

import { TravelExpenseTypeEnum } from '../../../../lib/types/enums/travel-expense/travel-expense.enum'
import { TravelExpenseInput } from '../../../../lib/types/models/travel-expenses/travel-expenses'
import EditableTable, { EditableTableColumn } from '../../../elements/editable-table'

type TravelExpensesTableProps = {
  title: string
  type: TravelExpenseTypeEnum
  columns: EditableTableColumn<TravelExpenseInput>[]
  data: TravelExpenseInput[]
  isEditable: boolean
  addText: string
  onDataChange: (values: TravelExpenseInput[], type: TravelExpenseTypeEnum) => void
  onAddNewTravelExpense: (type: TravelExpenseTypeEnum) => void
}

export function TravelExpensesTable({
  type,
  title,
  addText,
  onDataChange,
  onAddNewTravelExpense,
  ...props
}: TravelExpensesTableProps) {
  return (
    <div className="flex flex-col gap-3">
      <Typography variant="text">{title}</Typography>

      <div className="w-full overflow-x-auto">
        <EditableTable<TravelExpenseInput>
          {...props}
          disableHover
          overflow={false}
          onDataChange={(values) => onDataChange(values, type)}
          footer={
            props.isEditable && (
              <Button
                size="small"
                variant="ghost"
                icon={PlusIcon}
                onClick={() => onAddNewTravelExpense(type)}
                label={addText}
              />
            )
          }
        />
      </div>
    </div>
  )
}
